import React, { useEffect, useState } from "react";
import { Paper, Box, Typography, Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import Data from "./Data";
import Diffrance from "./Diffrance";
import Brand from "./Brand";
import ChooseUs from "./ChooseUs";
import HomeVideo from "../../../assets/HomeVideo/bxilayoutvideo.mp4";
import axios from "axios";

const MainHome = () => {
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    phone: '',
    company: '',
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {

    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const windowHeight = window.innerHeight;
      const fullHeight = document.documentElement.scrollHeight;
      const scrollPercentage = (scrollTop + windowHeight) / fullHeight;
      if (scrollPercentage >= 0.9) {
        const localstoragedata = localStorage.getItem("enrqiry")
        if (localstoragedata !== "sent") {
          setOpen(true);
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const restrictedDomains = ['gmail.com', 'yahoo.com', 'outlook.com', 'hotmail.com'];

  const validate = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.email) {
      newErrors.email = 'Email is required';
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = 'Invalid email format';
    } else if (restrictedDomains.some(domain => formData.email.endsWith(`@${domain}`))) {
      newErrors.email = 'Personal email domains are not allowed';
    }

    const phoneRegex = /^[0-9]{10,11}$/;
    if (!formData.phone) {
      newErrors.phone = 'phone number is required';
    } else if (!phoneRegex.test(formData.phone)) {
      newErrors.phone = 'Enter a valid phone number (10–11 digits)';
    }

    if (!formData.company.trim()) {
      newErrors.company = 'Company name is required';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    setErrors(prev => ({ ...prev, [name]: '' }));
  };

  const handleSubmit = async () => {
    if (!validate()) return;

    try {
      const response = await axios.post('https://production-api.unada.in/demoschedular/request_enquiry', { formData }).then((response) => {
        console.log("skdhfgisudgyfsdf", response?.data?.success)
        if (response?.data?.success) {
          localStorage.setItem("enrqiry", "sent")
          setOpen(false)
        }
      })

      if (response.ok) {
        console.log('Form submitted ✅');
        setOpen(false);
      } else {
        console.error('Submission failed ❌');
      }
    } catch (err) {
      console.error('Error submitting form:', err);
    }
  };

  const handleClose = () => {
    setOpen(false);
    localStorage.setItem("enrqiry", "sent")
  };

  return (
    <Paper elevation={0}>
      {/* Video sections */}
      <Box sx={{ width: "100%", maxHeight: "80%", mt: 2, display: { xl: "none", lg: "none", md: "none", sm: "grid", xs: "grid" } }}>
        <video autoPlay loop muted playsInline style={{ width: "100%", height: "auto", objectFit: "cover" }}>
          <source src={`https://bxidevelopment1.s3.ap-south-1.amazonaws.com/BxiStatic/bximobilebanner.mp4`} type="video/mp4" />
        </video>
      </Box>
      <Box sx={{ width: "100%", maxHeight: "80%", mt: 2, display: { xl: "grid", lg: "grid", md: "grid", sm: "none", xs: "none" } }}>
        <video autoPlay loop muted playsInline style={{ width: "100%", height: "auto", objectFit: "cover" }}>
          <source src={HomeVideo} type="video/mp4" />
        </video>
      </Box>

      <Data />
      <ChooseUs />
      <Diffrance />
      <Brand />

      {/* POPUP */}
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm"
        PaperProps={{
          component: Paper,
          elevation: 4,
          sx: {
            borderRadius: 3,
            p: 3,
            backgroundColor: 'rgb(255, 255, 255)',
            backdropFilter: 'blur(10px)',
            border: '1px solid rgba(255, 255, 255, 0.3)',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.25)',
            maxWidth: "400px",
          }
        }}
      >
        <DialogTitle>
          <Typography sx={TitleTextStyle}>Stay Connected with BXI</Typography>
          <Typography sx={TitleChildTextStyle}>Share your details and we’ll get in touch with you shortly.</Typography>
        </DialogTitle>

        <DialogContent>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            <Box>
              <label style={labelStyle}>Company Name</label>
              <input
                name="company"
                type="text"
                value={formData.company}
                onChange={handleChange}
                style={inputStyle}
              />
              {errors.company && <Typography sx={errorStyle}>{errors.company}</Typography>}
            </Box>
            <Box>
              <label style={labelStyle}>Email</label>
              <input
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                style={inputStyle}
              />
              {errors.email && <Typography sx={errorStyle}>{errors.email}</Typography>}
            </Box>
            <Box>
              <label style={labelStyle}>Phone No</label>
              <input
                name="phone"
                type="text"
                value={formData.phone}
                onChange={handleChange}
                style={inputStyle}
              />
              {errors.phone && <Typography sx={errorStyle}>{errors.phone}</Typography>}
            </Box>
          </Box>
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2, justifyContent: "flex-end", gap: 1 }}>
          <Button
            onClick={handleClose}
            variant="outlined"
            sx={CancelButtonStyle}
          >
            Skip
          </Button>
          <Button
            onClick={handleSubmit}
            variant="contained"
            sx={ButtonStyle}
          >
            Submit
          </Button>
        </DialogActions>

      </Dialog>
    </Paper>
  );
};

export default MainHome;

// STYLES
const TitleTextStyle = {
  fontFamily: "Poppins",
  fontSize: "16px",
  color: "#000",
  fontWeight: 500,
};

const TitleChildTextStyle = {
  fontFamily: "Poppins",
  fontSize: "11px",
  color: "#000",
  fontWeight: 400,
};

const labelStyle = {
  fontSize: "12px",
  fontWeight: 500,
  marginBottom: "4px",
  display: "block",
  fontFamily: "Poppins"
};

const inputStyle = {
  width: "100%",
  height: "30px",
  padding: "4px 10px",
  borderRadius: "6px",
  border: "1px solid #ccc",
  fontSize: "13px",
  outline: "none",
};

const errorStyle = {
  color: "red",
  fontSize: "12px",
  mt: 0.5,
};


const ButtonStyle = {
  borderRadius: "8px",
  background: "#2261a2",
  color: "#fff",
  textTransform: "none",
  fontWeight: 400,
  px: 4,
  py: 0.7,
  fontSize: "12px",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
  border: "1px solid #2261a2",
  '&:hover': {
    background: "#fff",
    color: "#2261a2",
    border: "1px solid #2261a2"
  }
}

const CancelButtonStyle = {
  borderRadius: "8px",
  borderColor: "#999",
  color: "#333",
  textTransform: "none",
  fontWeight: 400,
  px: 4,
  py: 0.6,
  fontSize: "12px",
  '&:hover': {
    backgroundColor: '#f1f1f1',
    borderColor: '#666',
  }
}